import React from 'react'
import { Image, Menu } from 'lib/ui'
import Link from 'lib/components/Link'

import useSessionUser from 'lib/hooks/useSessionUser'
import NavLink from 'lib/components/NavLink'

import UserButton from './UserButton'

const Nav = ({ isMobile = false, sidebarOnHide = () => {} }) => {
  const { auth: user, loading, error } = useSessionUser()

  const hideOnClick = () => {
    if (isMobile) sidebarOnHide()
  }

  if (error) {
    console.error('Nav.tsx useSessionUser error', error)
  }

  return (
    <>
      <Link href="/" passHref>
        <Menu.Item as="a" onClick={hideOnClick} className="!flex items-center">
          <Image
            src="/static/logo/white.svg"
            alt=""
            style={{ height: '32px', width: '32px' }}
          />
          Recall Monitor
        </Menu.Item>
      </Link>
      <NavLink href="/recalls" passHref loose>
        <Menu.Item as="a" onClick={hideOnClick}>
          Recent Recalls
        </Menu.Item>
      </NavLink>
      <NavLink href="/search" passHref>
        <Menu.Item as="a" onClick={hideOnClick}>
          Search Recalls
        </Menu.Item>
      </NavLink>
      <NavLink href="/pricing" passHref>
        <Menu.Item as="a" onClick={hideOnClick}>
          Pricing
        </Menu.Item>
      </NavLink>
      {!loading && user && (
        <>
          <NavLink href="/myalerts" passHref>
            <Menu.Item as="a" onClick={hideOnClick}>
              My Alerts
            </Menu.Item>
          </NavLink>
        </>
      )}
      <Menu.Item position={isMobile ? null : 'right'}>
        <UserButton onClick={hideOnClick} />
      </Menu.Item>
    </>
  )
}

export default Nav
